exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.v-input__control>.v-input__slot {\n   border-radius: 8px !important;\n}\n.Marge {\n   padding-left: 10%;\n   padding-right: 10%;\n}\n.v-input__control>.v-input__slot::before,\n .v-input__control>.v-input__slot::after {\n   border: 0px solid !important;\n}\n.v-btn {\n   font-size: 16px;\n   text-transform: none !important;\n}\ninput:focus {\n   outline: none;\n   box-shadow: none;\n}\ninput:-webkit-autofill {\n   box-shadow: 0 0 0 1000px #f0f0f0 inset !important;\n   -webkit-text-fill-color: #000 !important;\n}\ninput {\n   outline: none;\n   box-shadow: none;\n   background-color: transparent;\n   border-style: none;\n   color: inherit;\n}\n.theme--light.v-text-field--box>.v-input__control>.v-input__slot,\n .theme--light.v-text-field--box>.v-input__control>.v-input__slot:hover {\n   background-color: #f0f0f0 !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Login.vue
// module id = fkwj
// module chunks = 1